export interface MobileBffSendCodeRequestDto {
  phone: string;
}
